<template>
<!-- 提现审核 -->
<section class="draw">
  <el-col :span="24" class="draw_toolbar toolbar pad_left">
        <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <p style="margin: 0;margin-left: -22px;" class="goodslist1">
        <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
        <span class="goods_red"/>
      </p>
      <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
    </div>
      <el-collapse-transition>
      <div style="padding:0 12px" v-show="show3">
    <el-form :inline="true" :model="filters" class="findform" style="margin-top:10px;display:flex">
      <!-- 顶部搜索框 -->
      <el-form-item style="display:flex;width:100%"  label="关键词语：">
        <el-input style="width:100%" v-model="filters.name" placeholder="请输入申请人姓名"></el-input>
      </el-form-item>
      <el-form-item style="display:flex;width:100%" label="审核状态："  >
        <el-select
          v-model="filters.statusId"
          placeholder="请选择"
            style="background:#fff;width:100%"
          ref="mySelect"
        >
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in statusoptions"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="display:flex;width:100%" label="申请人身份：">
        <el-select
          v-model="filters.type"
          placeholder="请选择"
            style="background:#fff;width:100%"
          ref="mySelect1"
        >
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in typeoptions"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <el-form style="display:flex;position: relative;" class="findform">
      <el-form-item style="display:flex;width:32.4%" label="申请时间："  >
          <!-- <el-date-picker
            type="date"
            :editable = "false"
            class="normal_width"
            placeholder="选择日期"
            v-model="filters.date1"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        
        <span class="line till" >至</span>
          <el-date-picker
            placeholder="选择时间"
            :editable = "false"
            class="normal_width"
            v-model="filters.date2"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
          ></el-date-picker> -->
            <el-date-picker
              :title="value6"
          v-model="value6"
          :editable="iseditable"
          style="width:100%;cursor:pointer"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          @change="changetime"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item style="position: absolute;top:0;right:0">
        <el-button style="height:36px;line-height:1px" @click="onSubmit" class="toolbar_search">查询</el-button>
      </el-form-item>
    </el-form>
      </div>
      </el-collapse-transition>
      </div>
  </el-col>
  <el-col :span="24" class="draw_table pad_left">
    <section class="model_section">
      <p class="model_top_title">提现审核</p>
      <el-button type="danger" @click="editFormVisible()" v-if="menuAction.indexOf(1062)>-1"
      style="float: right;margin: 5px 10px 0 0;">导出Excel</el-button>
    </section>
    <div class="table_container" style="margin-top:10px">
      <div class="table_inner_container">
        <el-table :data="users" class="draw_tab" stripe border style="height:auto;max-height:500px" >
          <el-table-column prop="num" label="序号"  align="center">
            <template scope="scope">
              <span>{{scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="WithdrawalName" label="提现人"  align="center">
                <template scope="scope">
            <span :title="scope.row.WithdrawalName" :label="scope.row.WithdrawalName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.WithdrawalName}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="UserTypeName" label="身份"  align="center">
              <template scope="scope">
            <span :title="scope.row.UserTypeName" :label="scope.row.UserTypeName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.UserTypeName}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="Price" label="提现金额" align="center">
              <template scope="scope">
            <span :title="scope.row.Price" :label="scope.row.Price" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.Price}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="CTime" label="申请时间" align="center">
                <template scope="scope">
            <span :title="scope.row.CTime" :label="scope.row.CTime" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.CTime}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="AuditorName" label="审核人"  align="center">
                <template scope="scope">
            <span :title="scope.row.AuditorName" :label="scope.row.AuditorName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.AuditorName}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="Remark" label="审核意见"  align="center">
                <template scope="scope">
            <span :title="scope.row.Remark" :label="scope.row.Remark" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.Remark}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="StatusName" label="审核状态"  align="center">
              <template scope="scope">
            <span :title="scope.row.StatusName" :label="scope.row.StatusName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.StatusName}}</span>
        </template>
          </el-table-column>
          <el-table-column prop="AuditTime" label="审核时间"  align="center">
            <template scope="scope">
            <span :title="scope.row.AuditTime" :label="scope.row.StatusName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.AuditTime}}</span>
        </template>
          </el-table-column>
        <!-- <template scope="scope">
            <span :title="scope.row.AuditTime" :label="scope.row.AuditTime" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.AuditTime}}</span>
        </template> -->
          <el-table-column label="操作" fixed="right" width="240" align="center">
            <template slot-scope="scope">
              <div class="menuAction.indexOf(56)>-1">
                <span v-if="scope.row.StatusId==1" class="handle" @click="shenheedit(scope.row)">
                  <i class="el-icon-s-check"></i>审核
                </span>
                <span class="handle ac_btn_fail" v-else>
                  <i class="el-icon-s-check"></i>审核
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="total"
            :current-page="pageIndex"
            style="float:right;"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </el-col>
  <el-dialog class="add_bill_examine" width="622px" title="提现审核" :center="true" :visible.sync="shenFormVisble">
    <div v-show="isExamine">
      <el-form :model="form"   ref="cancleForm">
        <!-- <el-form-item label="审核意见：" style="width:300px;">
          <el-select
            placeholder="请选择"
            v-model="shenStatusId"
            style="background:#fff"
            @click="changeOption(option)"
          >
            <el-option
              v-for="item in statusaoptions"
              :key="item.index"
              :value="item.Id"
              :label="item.Name"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item  >
          <el-input type="textarea" placeholder="请输入审核备注" maxlength="60" v-model="shenmark" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div  style="padding-left:0;text-align:center">
        <!-- <p @click="billSubmit('form')"></p>
        <p @click="shenFormVisble = false">取消</p> -->
          <el-button type="danger" @click="billSubmit(3)">驳 回</el-button>
          <el-button type="danger" @click="billSubmit(2)">通 过</el-button>
      </div>
    </div>
    <!-- 审核成功 -->
    <div class="succ_exam" v-show="isSucc">
      <!-- 审核成功提示 -->
      <div class="succ_tips" style="text-align:center">
        <img src="../../assets/img/aicon15_03.jpg" alt style="width:100px;margin:0 auto" />
        <p class="shenhe">审核成功~</p>
      </div>
      <div class="examine_footer success que">
        <p class="shen" @click="change">确定</p>
        <i></i>
      </div>
    </div>
    <!-- 审核失败 -->
    <div class="succ_exam" v-show="isFail">
      <!-- 审核成功提示 -->
      <div class="succ_tips" style="text-align:center">
        <img src="../../assets/img/aicon15_06.jpg" alt />
        <p class="shenhe">审核失败~</p>
      </div>
      <div class="examine_footer success que" style="text-align:center;paddingleft:0">
        <p class="shen" @click="shenshibai">确定</p>
        <i></i>
      </div>
    </div>
  </el-dialog>
</section>
</template>
<script>
import { tixianshen, quetixianshen, changestatus} from "../../api/api";
import billExamine from "./billExamine";
export default {
  data() {
    return {
      show3:false,
      value6:"",
      iseditable:false,
      value6:"",
      // 审核弹窗
      shenFormVisble: false,
      isExamine: false,
      isSucc: false,
      isFail: false,
      examineFormVisble: false,
      filters: {
        name: "",
        options: [
          {
            value: "选项1",
            label: "黄金糕"
          },
          {
            value: "选项2",
            label: "双皮奶"
          },
          {
            value: "选项3",
            label: "蚵仔煎"
          }
        ],
        date1: "",
        date2: "",
        statusId: 0,
        type: 0
      },
      visible: false,
      users: [],
      total: 1,
      page: 1,

      form: {
        id: 0,
        theme: "",
        link: "",
        options: "",
        option2: ""
      },
      statusoptions: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "已提交"
        },
        {
          Id: 2,
          Name: "已审核"
        },
        {
          Id: 3,
          Name: "已驳回"
        }
      ],
      typeoptions: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "平台管家"
        },
        {
          Id: 2,
          Name: "共创端"
        },
        {
          Id: 3,
          Name: "个人用户"
        },
        {
          Id: 4,
          Name: "员工"
        }
      ],
      pageIndex: 1,
      pageSize: 10,
      statusoptions: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "已提交"
        },
        {
          Id: 2,
          Name: "已审核"
        },
        {
          Id: 3,
          Name: "已驳回"
        }
      ],
      statusaoptions: "",
      shenStatusId: "",
      tixianshenid: "",
      shenmark: ""
    };
  },

  p(s) {
    return s < 10 ? "0" + s : s;
  },
  methods: {
            changetime() {
                 if(this.value6+""=="null"){
           this.value6 = ["",""]
      }
      console.log(this.value6);
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    //提现审核
    tixianlist() {
      let that = this;
      console.log("23452345", that.filters.nature);
      var addParams = {
        key: that.filters.name,
        statusId: that.filters.statusId,
        type: this.filters.type,
        userId:localStorage.Id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        startTime: this.filters.date1,
        endTime: this.filters.date2
      };
      tixianshen(addParams)
        .then(data => {
          this.total = data.RowsCount;
          console.log(data);
          this.users = data.ResultObj;
        })
        .catch(err => {
          console.log(err);
          this.users = [];
        });
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    hide1() {
      this.$refs.mySelect1.handleClose();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.tixianlist();
    },

    editFormVisible() {
      var addParams = [
        { name: "userId", value: localStorage.Id },
        { name: "key", value: this.filters.name },
        { name: "statusId", value: this.filters.statusId },
        { name: "type", value: this.filters.type },
        { name: "startTime", value: this.filters.date1 },
        { name: "endTime", value: this.filters.date2 },
        { name: "pageIndex", value: this.pageIndex },
        { name: "pageSize", value: this.pageSize }
      ];
      var url = "/order/WithdrawalManage/ExportToExcel";
      this.downLoad(url, addParams);
    },

    getopinion() {
      let that = this;
      var loginParams = {
        tableName: "tBDWithdrawalStatus",
        keyWord: "",
        parentId: ""
      };
      changestatus(loginParams)
        .then(data => {
          data = data.ResultObj;
          that.statusaoptions = data;
          that.shenStatusId = data[0].Id;
          console.log(that.statusaoptions);
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //审核
    shenheedit(scope) {
      this.shenFormVisble = true;
      this.isExamine = true;
      this.shenmark = ""
      this.isSucc = false;
      this.isFail = false;
      this.tixianshenid = scope.Id;
      this.OrderId = scope.OrderId;
      console.log(this.shenFormVisble);
      console.log(this.isExamine);
    },
    //确定审核
    billSubmit(val) {
      if (this.shenmark == "") {
       this.$swal({
          type:"warning",
          text:"请输入审核意见"
        })
        return false;
      }
      let loginParams = {
        id: this.tixianshenid,
        remark: this.shenmark,
        status: val,
        operId: this.$cookie.get("OperatorId")
      };
      quetixianshen(loginParams).then(data => {
        console.log(data);
        this.shenFormVisble = false;
        this.isExamine = false;
        // shenFormVisble: false,
        // isExamine: false,
        // this.isSucc = true;
        this.$swal({
          type:"success",
          text:"审核成功~"
        })
        this.isFail = false;
        this.tixianlist();
      })
    
    },
    //审核成功
    change() {
      console.log(32747834);

      this.shenFormVisble = false;
      this.isSucc = false;
      this.tixianlist();
    },
    //审核失败
    shenshibai() {
      this.shenFormVisble = false;
      this.isFail = false;
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.tixianlist();
    }
  },
  components: {
    billExamine
  },
  mounted() {
    // this.getUsers();
    this.tixianlist();
    this.getopinion();
  },
  props: ['menuAction'],
  watch: {
    menuAction: function(val){
      this.menuAction = val
    }
  },
};
</script>
<style >
.filters_Name1 .el-form-item__content{
    width:53%
}
.filters_Name2 .el-form-item__content{
    width:43%
}
.filters_Name3 .el-form-item__content{
    width:73%
}
</style>

<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.draw .draw_toolbar {
  height: auto;
  color: #404040;
}

/* 时间  */
/* .draw_toolbar .line {
  margin-left: 10px;
  line-height: 36px;
} */
/* 时间图标 */
/* .draw_toolbar .line img{
  margin-top:8px
} */
/* 查询按钮 */
.draw_toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
  border-color: #ff4949;
}
/* 内容表格 */
.draw_table {
  min-height: 500px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  position: relative;
  margin-top: 10px;
}
/* 标题 */
.draw_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
/* 提现审核 */
.draw_table .el-col-22 p {
  width: 60px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.draw_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.draw_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
  font-size: 12px;
}

/* 表格操作 */
.draw_tab .draw_operation p {
  float: left;
  color: #677c9d;
  width: 68px;
  cursor: pointer;
}
.draw_tab .draw_operation p:first-child {
  margin-left: 20%;
}

/* 分页 */
.draw_toolbar_footer {
  position: absolute;
  bottom: 10px;
}
</style>
<style>

.el-col-24 .shen {
  width: 120px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  line-height: 55px;
}
.el-col-24 .shenhe {
  width: 100%;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  line-height: 55px;
  text-align: center;
}
.add_bill_examine .examine_footer {
  height: 40px;
  /* margin: 50px auto 28px; */
  padding-left: 88px;
  text-align: center;
}
.add_bill_examine .examine_footer p {
  display: inline-block;
  width: 85px;
  height: 38px;
  background-color: #F56C6C;
  border-radius: 3px;
  cursor: pointer;
  line-height: 38px;
  text-align: center;
  color: #fff;
}
.add_bill_examine .examine_footer p:last-child {
  border: solid 1px #F56C6C;
  background-color: #fff;
  color: #F56C6C;
  margin-left: 10px;
}
.que {
  padding-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// withdraw.vue?be29fc8c